






import { Vue, Prop, Component, Model, Emit, Watch } from 'vue-property-decorator'

@Component({
})
export default class MyRadioGroup extends Vue{
    @Prop({
        default: false
    }) disabled: boolean;
    @Prop({
        default: false
    }) isBtnGroup: boolean;
    @Model('change', {

    })
    propValueArr: any;

    @Watch('propValueArr')
    onChangePropValueArr(newValue) {
        this.emitChange(newValue);
    }

    @Emit('change')
    emitChange(newValue: any): void {

    }
}
